import { FC, useEffect, useState } from 'react'
import { Empty } from 'antd'
import classNames from 'classnames'
import dayjs from '@store/timetable/dayjs.config'
import Modal from '@common/Modal'
import Button from '@UI/New/Button'
import { IcoRemove } from '@/utils/icons'
import { useAddAlert } from '@/hooks/useAddAlert'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import FieldWrapper from '@pages/Admin/CourseSettings/components/FieldWrapper/FieldWrapper'
import Preloader from '@UI/Preloader'
import { IGroupLessonPaymentByLessonItem } from '../../../../utils/types'
import {
  getStatusColor,
  getStatusDescription,
} from '../../../../utils/lessonStatus'
import { getLessonIncomeDetails, ILessonIncomeDetails } from './utils/api'
import cn from './index.module.css'

interface IViewLessonIncomeModal {
  open: boolean
  lesson: IGroupLessonPaymentByLessonItem | null
  onDismiss: () => void
}

const ViewLessonIncomeModal: FC<IViewLessonIncomeModal> = (props) => {
  return (
    <Modal
      active={props.open}
      className={classNames(mclasses.modalWrapper, cn.modalWrapper) as any}
      setActive={() => props.onDismiss()}
    >
      <Body {...props} />
    </Modal>
  )
}

const Body: FC<IViewLessonIncomeModal> = ({ lesson, open, onDismiss }) => {
  const addAlert = useAddAlert()
  const [loading, setLoading] = useState(false)
  const [details, setDetails] = useState<ILessonIncomeDetails | null>(null)

  useEffect(() => {
    if (!open) return

    setDetails(null)

    if (!lesson?.id) {
      addAlert({
        title: 'Ошибка',
        text: 'Не удалось определить занятие',
        type: 'error',
      })
      return
    }

    let isActive = true

    const loadIncomeDetails = async () => {
      setLoading(true)
      const response = await getLessonIncomeDetails(Number(lesson.id))

      if (!isActive) return

      setLoading(false)

      if (!response.success) {
        addAlert({
          title: 'Ошибка',
          text: response.error || 'Не удалось загрузить доход по занятию',
          type: 'error',
        })
        return
      }

      setDetails(response.data)
    }

    loadIncomeDetails()

    return () => {
      isActive = false
    }
  }, [lesson?.id, open])

  const students = details?.students ?? []

  return (
    <div className={mclasses.modalContainer}>
      <div className={mclasses.modalHeader}>
        <div className={mclasses.modalTitleContainer}>
          <span className={mclasses.modalHeaderTitle}>Доход по занятию</span>
        </div>
        <div className={mclasses.closeIcon} onClick={onDismiss}>
          <IcoRemove />
        </div>
      </div>
      <div className={classNames(mclasses.formWrapper, cn.form)}>
        {/* <div className={cn.lessonInfo}>
          <FieldWrapper label={'Курс'} className={cn.lessonInfoItem}>
            <span className={cn.lessonInfoValue}>
              {lesson?.course?.name ?? '-'}
            </span>
          </FieldWrapper>
          <FieldWrapper label={'Группа'} className={cn.lessonInfoItem}>
            <span className={cn.lessonInfoValue}>
              {lesson?.group?.name ?? '-'}
            </span>
          </FieldWrapper>
          <FieldWrapper label={'Дата и время'} className={cn.lessonInfoItem}>
            <span className={cn.lessonInfoValue}>
              {formatLessonDate(lesson?.date_time)}
            </span>
          </FieldWrapper>
          <FieldWrapper label={'Итого'} className={cn.lessonInfoItem}>
            <span className={cn.lessonInfoValue}>
              {formatAmount(details?.total ?? lesson?.income)}
            </span>
          </FieldWrapper>
        </div> */}
        {loading ? (
          <div className={cn.loading}>
            <Preloader />
          </div>
        ) : students.length ? (
          <div className={cn.table}>
            <div className={classNames(cn.row, cn.headerRow)}>
              <span>Ученик</span>
              <span>Статус</span>
              <span className={cn.amount}>Сумма</span>
            </div>
            <div className={cn.rows}>
              {students.map((student) => (
                <div className={cn.row} key={student.student_id}>
                  <span className={cn.studentName}>
                    {student.student_name || '-'}
                  </span>
                  <div className={cn.statusCell}>
                    <span
                      className={cn.statusMarker}
                      style={{
                        backgroundColor: getStatusColor(String(student.status)),
                      }}
                      title={
                        student.status_label ||
                        getStatusDescription(String(student.status))
                      }
                    />
                    <span className={cn.statusText}>
                      {student.status_label ||
                        getStatusDescription(String(student.status))}
                    </span>
                  </div>
                  <span className={cn.amount}>{(student.amount ?? 0) + `₽`}</span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Ученики не найдены"
          />
        )}
      </div>
      <div className={mclasses.actions}>
        <Button color="gray" onClick={onDismiss}>
          Закрыть
        </Button>
      </div>
    </div>
  )
}

export default ViewLessonIncomeModal
